export default __webpack_public_path__ + "static/media/Wastewater.a20da4e6.svg";